// import { stringify as stringifyQs } from "qs";
import { stringifyQs } from "@saleor/utils/urls";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  Sort,
  TabActionDialog
} from "../types";

export const emailTemplateSection = "/emailTemplate/";
export const emailTemplateListPath = emailTemplateSection;
export enum RotaryListUrlFiltersEnum {
  number = "number",
  isEnable = "isEnable",
  query = "query"
}
export enum RotaryListUrlSortField {
  name = "name",
  number = "number",
  isEnable = "isEnable",
  createDate = "createDate",
  startDate = "startDate",
  endDate = "endDate"
}
export type RotaryListUrlFilters = Filters<RotaryListUrlFiltersEnum>;
export type RotaryListUrlSort = Sort<RotaryListUrlSortField>;
export type RotaryListUrlDialog = "remove" | TabActionDialog;

export type RotaryListUrlQueryParams = ActiveTab &
  RotaryListUrlFilters &
  RotaryListUrlSort &
  BulkAction &
  Dialog<RotaryListUrlDialog> &
  Pagination;
export const rotaryListUrl = (params?: RotaryListUrlQueryParams) =>
  emailTemplateListPath + "?" + stringifyQs(params);

export type RotaryUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove"
  | "remove-value"
  | "remove-values";

export type RotaryUrlQueryParams = BulkAction &
  Dialog<RotaryUrlDialog> &
  SingleAction;

export const emailTemplatePath = (id: string) =>
  urlJoin(emailTemplateSection, id);

export type RotaryAddUrlDialog =
  | "add-value"
  | "edit-value"
  | "remove-value"
  | "remove-values";
export type RotaryAddUrlQueryParams = Dialog<RotaryAddUrlDialog> & SingleAction;

export const rotaryAddPath = urlJoin(emailTemplateSection, "add");

export const emailTemplateUrl = (id: string, params?: RotaryUrlQueryParams) =>
  emailTemplatePath(encodeURIComponent(id)) + "?" + stringifyQs(params);
